<template>
  <div class="max_style">
    <div class="spu_layout_style">
      <div class="package_style">
        <img
          class="package_img_style"
          :src="cgmPackage.packageImg"
          alt=""
          srcset=""
        />
        <div class="sp_style">
          <div class="package_name_style">{{ cgmPackage.packageName }}</div>
          <div class="package_na_style">{{ cgmPackage.packageIntroduce }}</div>
        </div>
      </div>
      <div class="spu_title_style">包含药品</div>
      <div>
        <div class="spu_for_style" v-for="item in cgmSpuList" :key="item.spuId">
          <div class="spu_style">
            <img class="spu_img_style" :src="item.spuImg" alt="" srcset="" />
            <div>
              <div class="spu_name_style">{{ item.spuName }}</div>
              <div class="spu_introduce_style">{{ item.spuIntroduce }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="apply_style" @click="return_click">返回</div>
    </div>
    <el-dialog
      title="支付"
      :visible.sync="centerDialogVisible"
      center
      width="30%"
    >
      <div class="qr_style">
        <qrcode-vue
          :value="nihaopay_qr_code"
          :size="size"
          level="H"
        ></qrcode-vue>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="pay_confirm_click">已支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { pcaTextArr } from "element-china-area-data";

import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["cgmUserVO", "leftItem"]),
  },
  data() {
    return {
      userAddress: null,
      province: null,
      city: null,
      district: null,
      address: null,
      receiving: null,
      receivingMobile: null,
      vendor: "wechatpay",
      pcaTextArr,
      selectedOptions: [],
      nihaopay_qr_code: null,
      size: 300,
      centerDialogVisible: false,
      loading: false,
      cgmPackage: {},
      cgmSpuList: [],
    };
  },
  mounted() {
    this.cgmSpuRecords();
  },
  methods: {
    ...mapMutations(["setCgmUserVO", "setLeftItem"]),
    return_click() {
      this.$router.back();
    },
    handleChange(value) {
      this.province = value[0];
      this.city = value[1];
      this.district = value[2];
    },
    cgmSpuRecords() {
      this.axios
        .get("/cgmSpu/getByPackageId", {
          params: {
            packageId: this.$route.query.packageId,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.cgmPackage = res.data.data;
            this.cgmSpuList = res.data.data.cgmSpuList;
          }
        });
    },
    buy_click() {
      if (this.cgmUserVO) {
        let userId = JSON.parse(this.cgmUserVO).userId;
        this.axios
          .get("/cgmAddress/get", {
            params: {
              userId,
            },
          })
          .then((res) => {
            if (res.data.code == 200 && res.data.data != null) {
              this.loading = true;
              this.axios
                .post(
                  "/securePay",
                  {
                    userId,
                    packageId: this.$route.query.packageId,
                    province: this.province,
                    city: this.city,
                    district: this.district,
                    address: this.address,
                    receiving: this.receiving,
                    receivingMobile: this.receivingMobile,
                    vendor: this.vendor,
                  },
                  {
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded",
                    },
                  }
                )
                .then((res) => {
                  if (res.data.code == 200) {
                    this.loading = false;
                    let w = window.open("", "_self");
                    w.document.write(res.data.data);
                  }
                });
            } else {
              const ua = navigator.userAgent.toLowerCase();
              if (/phone|mobile|android|iphone|ipad|ipod/i.test(ua)) {
                this.$router.push({
                  path: "/userAddress",
                });
              } else {
                this.setLeftItem(4);
                this.$router.push({
                  path: "/userCenter",
                });
              }
              this.$message({ type: "error", message: "请先填写收货地址" });
            }
          });
      } else {
        this.$router.push({ path: "/login" });
        this.$message({ type: "error", message: "请登录" });
      }
    },
    pay_confirm_click() {
      this.centerDialogVisible = false;
      this.$router.push({ path: "/order" });
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width:768px) {
  .package_style {
    flex-wrap: wrap;
  }
  .spu_style {
    flex-wrap: wrap;
    justify-content: center;
  }
  ::v-deep .el-dialog {
    width: 100% !important;
  }
  // .sp_style {
  //   padding: 0 10px;
  // }
  .spu_title_style {
    padding: 20px !important;
    width: 90% !important;
  }
  .apply_style {
    border-radius: 200px !important;
    width: 80% !important;
  }
  .package_img_style {
    width: 100% !important;
    height: 100% !important;
  }
}
.package_name_style {
  padding-top: 30px;
  font-size: 22px;
  color: #e0000f;
}
.package_na_style {
  margin: 10px 0 20px;
  font-size: 32px;
  color: #000;
  font-weight: bold;
}
.qr_style {
  display: flex;
  justify-content: center;
}
.detail_style {
  margin-bottom: 10px;
  margin-left: 20px;
}
.detail_style ::v-deep .el-input__inner {
  width: 320px;
}
.address_style {
  margin-bottom: 40px;
  background: #fff;
  border-radius: 10px;
  padding: 40px 0 40px 0;
}
.address_style1 {
  font-size: 18px;
  margin-bottom: 40px;
}
.spu_introduce_style {
  color: #9c9c9c;
}
.spu_title_style {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
  width: 100%;
}
.spu_layout_style > div {
  max-width: 960px;
}
.spu_layout_style {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f6f7;
}
.apply_style {
  background: #e0000f;
  color: #fff;
  margin-bottom: 35px;
  padding: 20px 0;
  border-radius: 10px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  width: 100%;
}
.package_style {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  margin: 36px 0;
  font-size: 24px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}
.package_img_style {
  // width: 350px;
  height: 233px;
}
.spu_for_style {
  border-radius: 12px;
  padding: 16px 16px 20px;
  margin-bottom: 20px;
  background-color: #fcfdfd;
}
.spu_style {
  display: flex;
  align-items: center;
  gap: 20px;
}
.spu_img_style {
  width: 170px;
  height: 100%;
}
.spu_name_style {
  // margin-bottom: 40px;
  font-size: 24px;
  font-weight: bold;
}
</style>